import axios from 'axios';

import i18n from '../i18n';

export function getmealplan(calories) {
  const api_url = process.env.API_URL + 'demo';
  //console.log(api_url);
  let data = {calories};
  return axios.post(api_url, data)
    .then(res => {
      //console.log('ghot it');
      return res.data;
    })
    //.catch(error => {
    //  throw(error);
    //    })
}

export function postinvitationrequest(email, motivation) {
  const api_url = process.env.API_URL + 'users/invitationrequest';
  let language = i18n.language.substring(0,2);
  let data = {email, motivation, language};
  //console.log(api_url);
  return axios.post(api_url, data)
  .then(res => {
    return res.data;
  })
}

export function validateinvitationrequest(code) {
  const api_url = process.env.API_URL + 'users/invitationrequest/' + code;
  //console.log(api_url);
  let language = i18n.language.substring(0,2);
  return axios.put(api_url, {language})
  .then(res => {
    return res.data;
  })
}